<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>

      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px;height:auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Container Repair Conditions</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button variant="warning" size="sm" v-if="showMain==false" @click="goToMain">Add New</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-row>
              <b-col md="10"  v-if="showMain==true">
                <b-button
                  class="pull-right"
                  variant="outline-info"
                  size="sm"
                  @click="openMain('dialog2')"
                >Add Main Condition</b-button>
              </b-col>
              <b-col md="2"  v-if="showMain==true">
                <b-button
                  variant="outline-info"
                  size="sm"
                  @click="openSub('dialogSub')"
                >Add Sub Condition</b-button>
              </b-col>
            </b-row>
            <b-row v-if="showMain==true" >
              <b-col md="6">
                <label>Main Condition</label>
                <model-list-select
                  :list="shippingLineMaster"
                  v-model="subContainer.repairId"
                  option-value="repairId"
                  option-text="repairCondition"
                  placeholder="Select Main Condition"
                ></model-list-select>
                <span class="error" v-if="!subContainer.repairId">{{shippingLineError}}</span>
              </b-col>
              <b-col md="6">
                <label>Sub Condition</label>
                <model-list-select
                  :list="subConditionMaster"
                  v-model="subContainer.repairSideId"
                  option-value="repairSideId"
                  option-text="repairSideName"
                  placeholder="Select Sub Condition"
                ></model-list-select>

                <span
                  class="error"
                  v-if="!subContainer.repairSideId"
                >{{containerConditionError}}</span>
              </b-col>
            </b-row>
            <b-row v-if="showMain==true" >
              <b-col md="12">
                <md-layout md-flex="100">
                  <label>Sub Container Condition</label>
                  <b-form-textarea :formatter="capitalizeAll"
                    id="repairSubName"
                    name="repairSubName"
                    v-model="subContainer.repairSubName"
                  ></b-form-textarea>
                </md-layout>
                <span
                  class="error"
                  v-if="!subContainer.repairSubName"
                >{{subContainerConditionError}}</span>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="showMain==true" >
              <b-col md="12" style="text-align: center;">
                <b-button
                  variant="primary"
                  @click="addVehicleSize"
                  id="addButtonLoader"
                >{{subContainer.repairSubId == ""?"Add":"edit"}}</b-button>
                <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
              </b-col>
            </b-row>
            <div>
              <md-dialog
                class="HereDialogPass"
                md-open-from="#custom"
                md-close-to="#custom"
                ref="dialog2"
                :md-click-outside-to-close="false"
              >
                <md-dialog-content>
                  <md-layout md-gutter>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="90">
                      <label>
                        <u>Main Condition</u>
                      </label>
                    </md-layout>
                    <md-layout class="close-box">
                      <md-button
                        style="min-width: 20px; margin: 0;"
                        class="md-raised md-dense modal-close-btnn"
                        @click="closeModal()"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="mt-3">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="90">
                      <label>Main Condition</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="repairCondition"
                        name="repairCondition"
                        v-model="mainModal.repairCondition"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-dialog-content>

                <md-dialog-actions class="justify-content-center">
                  <md-button
                    class="md-raised md-primary md-button-color heght-1px"
                    @click="addMainConditn"
                  >Add</md-button>
                </md-dialog-actions>
              </md-dialog>
              <md-dialog
                class="HereDialogPass"
                style
                md-open-from="#custom"
                md-close-to="#custom"
                ref="dialogSub"
                :md-click-outside-to-close="false"
              >
                <md-dialog-content>
                  <md-layout md-gutter>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="90">
                      <label>
                        <u>Sub Condition</u>
                      </label>
                    </md-layout>
                    <md-layout class="close-box">
                      <md-button
                       style="min-width: 20px; margin: 0;"
                        class="md-raised md-dense modal-close-btnn"
                        @click="closeModal()"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-layout>
                  </md-layout>
                  <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <label>Main Condition</label>
              <model-list-select
                :list="shippingLineMaster"
                v-model="subModal.repairId"
                option-value="repairId"
                option-text="repairCondition"
                placeholder="Select Main Condition"
              ></model-list-select>
            </md-layout>
                  </md-layout>-->
                  <md-layout md-gutter class="mt-3">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="90">
                      <label>Sub Condition</label>
                      <b-form-input :formatter="capitalizeAll"
                        id="repairSideName"
                        name="repairSideName"
                        v-model="subModal.repairSideName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-dialog-content>

                <md-dialog-actions class="justify-content-center">
                  <md-button
                    class="md-raised md-primary md-button-color heght-1px"
                    @click="addSubConditn"
                  >Add</md-button>
                </md-dialog-actions>
              </md-dialog>
              <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopDia"></md-dialog-alert>
            </div>
            <b-container fluid class="mt-3">
              <!-- User Interface controls -->
              <b-row>
                <b-col md="12" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="filter" placeholder="Type to Search"/>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        <b-button
                          size="sm"
                          class="ml-2"
                          :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                          @click="truckSize('Excel')"
                          variant="outline-info"
                          > {{ ExcelBtnName }}
                          <b-spinner
                            v-if="ExcelBtnName != 'Export as Excel'"
                            small
                            label="Small Spinner"
                          ></b-spinner
                        ></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="subDetail"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="repairId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="repairCondition" slot-scope="row1">
                    <span
                      @click="editData(row1.item)"
                      class="showMoreData"
                    >{{row1.item.repairCondition}}</span>
                  </template>

                  <template slot="isActiveSubName" slot-scope="row1">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row1.item.repairSubId">
                      <md-switch
                        :id="'approval' + row1.item.repairSubId"
                        name="approval"
                        class="md-primary"
                        :value="row1.item.isActiveSubName == 1 ? true : false"
                        @change="activateUser(row1.item)"
                      >
                        <h6>
                          <br/>
                          <b-badge style="margin-left: -45px">{{
                            row1.item.isActiveSubName == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row1.item.repairSubId">
                      <h6>
                        <b-badge>{{
                          row1.item.isActiveSubName == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </div>
                  </template>

                </b-table>
              </div>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="25"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop3"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Yard")) {
      this.$store.dispatch("setCurrentRoute", "/yard/GateIn");
      this.truckSize("Normal");
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      fields: [
        {
          key: "repairId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "repairCondition",
          label: "Main Condition",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "repairSideName",
          label: "Sub-Side Condition",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "repairSubName",
          label: "Sub condition",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isActiveSubName",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      isLoading: false,
      showMain: false,
      deleteId: "",
      mainModal: {
        repairCondition: "",
        repairId: ""
      },
      subModal: {
        repairSideId: "",
        repairId: "",
        repairSideName: ""
      },
      subContainer: {
        repairSideId: "",
        repairId: "",
        repairSubId: "",
        repairSubName: ""
      },
      vehicleSizeMaster: [{}],
      shippingDetails: [{}],
      subConditionMaster: [],
      validate: true,
      shippingLineError: "",
      subContainerConditionError: "",
      //    materialCostError: "",
      containerConditionError: "",
      excelUpload: "",
      shippingLineMaster: [],
      subDetail: [],

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.showMain = true;
    },
    addSubConditn() {
      // if (this.subModal.repairId == "") {
      //   this.alert.content = "Please Select Condition";
      //   this.$refs["addPop"].open();
      //   return false;
      // } else
      if (this.subModal.repairSideName == "") {
        this.alert.content = "Please Enter Sub Condition";
        this.$refs["addPop"].open();
        return false;
      } else {
        let array1 = this.subConditionMaster.filter(x => {
          return (
            x.repairSideName.toLowerCase() ==
            this.subModal.repairSideName.toLowerCase()
          );
        });
        if (array1.length > 0) {
          this.alert.content =
            "Already Exist " + this.mainModal.repairCondition;
          this.$refs["addPop"].open();
          return false;
        }
      }

      //   this.validateAddTruckForm();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/addRepairSides.php`,
        data: JSON.stringify(this.subModal),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          this.subConditionMaster.push(result.data.repairConditionData[0]);
          this.subModal.repairSideName = "";
          this.$refs["dialogSub"].close();

          // this.$refs["addPop"].open();
        })
        .catch(error => {});
    },
    addMainConditn() {
      if (this.mainModal.repairCondition == "") {
        this.alert.content = "Please Enter Condition";
        this.$refs["addPop"].open();
        return false;
      } else {
        let array1 = this.shippingLineMaster.filter(x => {
          return (
            x.repairCondition.toLowerCase() ==
            this.mainModal.repairCondition.toLowerCase()
          );
        });
        if (array1.length > 0) {
          this.alert.content =
            "Already Exist " + this.mainModal.repairCondition;
          this.$refs["addPop"].open();
          return false;
        }
      }

      //   this.validateAddTruckForm();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/addRepairCondition.php`,
        data: JSON.stringify(this.mainModal),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          this.shippingLineMaster.push(result.data.repairConditionData[0]);
          this.mainModal.repairCondition = "";
          this.$refs["dialog2"].close();

          // this.$refs["addPop"].open();
        })
        .catch(error => {});
    },
    closeModal() {
      (this.mainModal.mainCondition = ""),
        (this.mainModal.subCondition = ""),
        this.$refs["dialog2"].close();
      this.$refs["dialogSub"].close();
    },
    openMain() {
      this.$refs["dialog2"].open();
    },
    openSub() {
      this.$refs["dialogSub"].open();
    },

    JqueryFun() {
      return $(function() {
        return $("#SubContainerCondition").DataTable();
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.subContainer.repairId == "") {
        $("#repairId").focus();
        this.shippingLineError = "Select Main Condition";
        validate_new = false;
      } else {
        this.shippingLineError = "";
      }

      if (this.subContainer.repairSideId == "") {
        $("#repairSideId").focus();
        this.containerConditionError = "Select Sub Condition";
        validate_new = false;
      } else {
        this.containerConditionError = "";
      }

      //   if (this.subContainer.materialCost == "") {
      //     $("#materialCost").focus();
      //     this.materialCostError = "Enter Material Cost";
      //     validate_new = false;
      //   }

      if (this.subContainer.repairSubName == "") {
        $("#repairSubName").focus();
        this.subContainerConditionError = "Enter Sub-Container Condition";
        validate_new = false;
      } else {
        this.subContainerConditionError = "";
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addVehicleSize() {
      this.validateAddVehicleSizeForm();
      if (this.subContainer.repairSubId == "") {
        let array1 = this.subDetail.filter(x => {
          return (
            x.repairId.toLowerCase() ==
              this.subContainer.repairId.toLowerCase() &&
            x.repairSideId.toLowerCase() ==
              this.subContainer.repairSideId.toLowerCase() &&
            x.repairSubName.toLowerCase() ==
              this.subContainer.repairSubNName.toLowerCase()
          );
        });
        if (array1.length > 0) {
          this.alert.content =
            "Already Exist " + this.subContainer.repairSubName;
          this.$refs["addPop"].open();
          return false;
        }
      }

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addRepairSubCondition.php`,
          data: JSON.stringify(this.subContainer),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");

            if (this.subContainer.repairSubId == "") {
              this.alert.content = "Data Added Successfully";
            } else {
              this.alert.content = "Data Updated Successfully";
            }
            this.$refs["addPop6"].open();
            this.truckSize("Normal");
            this.showMain = false;
            this.JqueryFun();
          })
          .catch(error => {});
      }
    },

    editData(item1) {
      this.showMain = true;
      Object.keys(this.subContainer).map(x => {
        this.subContainer[x] = item1[x] || "";
      });
      window.scroll(0, 0);
    },

    truckSize(type) {
      this.isLoading = true;
      let type_Size = {
        truckSize: "truckSize",
        Param:'List',
        type: type
      };

      if(type == "Excel"){
        this.ExcelBtnName = "Downloading....";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewSubRepairDetails.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.truckSizeDetails.length > 0) {
              this.shippingLineMaster = data.truckSizeDetails;
            }

            if (data.containerCondition.length > 0) {
              this.subConditionMaster = data.containerCondition;
            }

            if (data.subcontainerCondition.length > 0) {
              this.subDetail = data.subcontainerCondition;
              this.totalRows = data.subcontainerCondition.length;
            }

            if (type == "Excel") {
              if (data.subcontainerCondition.length > 0) {
                this.subDetail = data.subcontainerCondition;
                this.totalRows = data.subcontainerCondition.length;
                this.ExcelBtnName = "Export as Excel";
              }
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.subcontainerCondition.length > 0) {
                this.subDetail = data.subcontainerCondition;
                this.totalRows = data.subcontainerCondition.length;
                console.log("Sub Container Master List response=>", data);
              }
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "yard_containercondition",
          tableId: "containerConditionId",
          tableIsActive: "isConditionActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Yard/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              this.JqueryFun();
              this.truckSize("Normal");
              // console.log(data);
            }
          })
          .catch(error => {});
      }
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.repairSubId;

      this.itemObj.isActiveSubName = this.itemObj.isActiveSubName == 1 ? 0 : 1;
      let paylod = {
        tableName: "repair_sub_condition",
        tableId: "repairSubId",
        tableIsActive: "isActiveSubName",
        value1: this.itemObj.isActiveSubName,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.truckSize("Normal");
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container.HereDialogPass.md-theme-default .md-dialog {
  width: 40%;
  height: 50%;
  border-radius: 10px;
}
/* .modalClose {
  width: 32px;
  min-width: 32px;
  height: 32px;
  min-height: 32px;
  padding: 4px;
  line-height: 32px;
  margin-top: -21px;
  background-color: cyan;
} */
.md-dialog-container.HereDialogPass.md-theme-default .md-dialog {
  width: 40%;
  height: 60%;
  border-radius: 6px;
}
.close-box{
  position: fixed;
  right: 0.5rem;
  top: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// repairMainCondition.vue?f4fae68e